<template>
    <div class="assets_detail">
        <header>
            <span class="btn" @click="goBack"><van-icon name="arrow-left" size="20" /></span>
            <span class="item" :class="{ active: currentTab == 0 }" @click="changeTab(0)">预览</span>
            <span class="item" :class="{ active: currentTab == 1 }" @click="changeTab(1)">信息</span>
            <span class="item" :class="{ active: currentTab == 2 }" @click="changeTab(2)">详情</span>
        </header>
        <div class="model_wrapper" v-if="modelInfo.previewUrl && !isLoading" v-show="currentTab == 0">
            <ModelViewer :url="modelInfo.previewUrl" :background="modelInfo.modelBgImage" />
        </div>

        <div class="model_info" v-if="currentTab == 1">
            <ul>
                <li><span>格式</span> {{ modelInfo.modelFormat }}</li>
                <li><span>大小</span> {{ modelInfo.modelSizeWithUnit }}</li>
                <li><span>面数</span> {{ modelInfo.modelFace }}</li>
                <li><span>顶点数</span> {{ modelInfo.modelVertex }}</li>
                <li><span>布线类型</span> {{ ['三边形', '四边形'][modelInfo.topologyType || 0] }}</li>
                <li><span>关于UV</span> {{ ['未展开', '已展开有重叠', '已展开不重叠', '混合'][modelInfo.uvStatus || 2] }}</li>
                <li><span>动画</span> {{ modelInfo.isAnimation }}</li>
                <li><span>贴图</span> {{ modelInfo.modelChartlets }}</li>
                <li><span>材质</span> {{ modelInfo.isMaterial }}</li>
            </ul>
        </div>
        <div style="height: 300rem;" v-if="currentTab == 2"></div>
        <div class="info">
            <h5>
                <span>{{ modelInfo.modelName }}</span>
                <div>
                    <van-icon :name="require('@/assets/imgs/icon6.png')" size="18" v-if="!modelInfo.isLike"
                        @click="likeModel" />
                    <van-icon :name="require('@/assets/imgs/icon18.png')" size="18" v-else @click="likeModel" />
                    <van-icon :name="require('@/assets/imgs/icon62.png')" size="16" v-if="modelInfo.isFavorite"
                        @click="favoriteModel" />
                    <van-icon :name="require('@/assets/imgs/icon27.png')" size="16" v-else @click="favoriteModel" />
                    <van-icon @click="toShare" :name="require('@/assets/imgs/icon28.png')" size="16" />
                </div>
            </h5>
            <p>{{ timeStampFormat(modelInfo.createTime) }}</p>
            <p @click="copyToClipboard(modelInfo.modelId)">ID: <span>{{ modelInfo.modelId }}</span><van-icon :name="require('@/assets/imgs/icon29.png')"
                    size="16" /> </p>
            <p @click="copyToClipboard(modelInfo.chainAddress)">哈希值: <span>{{ modelInfo.chainAddress }}</span> <van-icon :name="require('@/assets/imgs/icon29.png')"
                    size="16" /></p>
        </div>

        <div class="licens">
            <h5 style="justify-content: flex-start;">授权类型 <span>（请在PC端进行购买/下载操作）</span> </h5>
            <van-radio-group v-model="licenseType" shape="dot">
                <van-radio :name="index + 1" v-for="(item, index) in modelInfo.modelLicens" :key="item.id">
                    <div class="licens_item">
                        <span>{{ item.name }}</span> <span>{{ getPrice(item.priceVO) }}</span>
                    </div>
                </van-radio>
            </van-radio-group>

            <h5 style="margin-top: 20rem;">{{ ['个人授权范围', '企业授权范围', '企业扩展授权范围'][licenseType - 1] }}
                <button v-if="licenseType == 1"><a href="/documents/授权合约(个人).pdf" target="_blank">授权合约模版</a></button>
                <button v-else-if="licenseType == 2"><a href="/documents/授权合约(企业).pdf"
                        target="_blank">授权合约模版</a></button>
                <button v-else><a href="/documents/授权合约(企业扩展).pdf" target="_blank">授权合约模版</a></button>
            </h5>
            <div v-html="modelInfo.modelLicens[licenseType - 1]?.scope" class="desc"></div>
        </div>


        <div class="intro">
            <h5><span>介绍</span></h5>
            <div v-html="modelInfo.modelIntro" class="intro_content"></div>
        </div>

        <div class="author">
            <div class="author_info">
                <img :src="author.avatar" alt="" @click="router.push('/author?id=' + author.id)">
                <div>
                    <h5>{{ author.nickname }}</h5>
                    <p>资产: {{ author.assetCount }} <span style="display: inline-block; width: 30rem;"></span> 粉丝：{{
                        author.followCount }}</p>
                </div>
                <button v-if="author.follow == 0 || !author.follow" @click="toFollow">关注</button>
                <button @click="toFollow" v-else>已关注</button>
            </div>
            <div class="line"></div>
            <div class="list">
                <ul>
                    <li v-for="item in author.recommend" @click="jumpToDetail(item)"
                        :style="{ backgroundImage: 'url(' + (item.modelBgImage || 'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background01.png') + ')' }">
                        <img :src="item.picUrl.split(';')[0]" alt="">
                    </li>
                </ul>
            </div>
        </div>
<!-- 
        <div class="articles">
            <h5>相关文章推荐</h5>
            <NewsItem v-for="item in newsList" :key="item.id" :data="item" />
        </div> -->

        <div class="guess_like">
            <h5>猜你喜欢</h5>
            <ul class="list">
                <li v-for="item in recommendList" @click="jumpToDetail(item)">
                    <AssetsCard :item="item" />
                </li>
            </ul>
        </div>
        <!-- <footer>
            <button>查看实物商城</button>
            <button>购买数字藏品</button>
        </footer> -->
    </div>

    <ShareDialog ref="shareDialog" />
</template>
<script setup>
import ModelViewer from '@/views/front/components/ModelViewer.vue'
import AssetsCard from '@/views/front/components/AssetsCard.vue'
import { onMounted, reactive, ref, watch } from 'vue'
import { throttle } from 'lodash-es';
import ShareDialog from '@/views/front/components/ShareDialog.vue'
import { useRoute, useRouter } from 'vue-router';
import { getModelRelatedArticle } from '@/request/front';
import { http } from '@/request/http';
import { timeStampFormat } from '@/utils/util'
import icon1 from '@/assets/imgs/icon30.png'
import icon2 from '@/assets/imgs/icon31.png'
import NewsItem from '@/views/front/components/NewsItem.vue';
import { copyToClipboard } from '@/utils/util';

const route = useRoute(), router = useRouter()
const currentTab = ref(0)

const changeTab = (index) => {
    currentTab.value = index
}
// var baseUrl = 'https://www.bolanzg.com'
// if(process.env.NODE_ENV == 'development'){
//     baseUrl = 'http://192.168.1.159'
// }
const modelInfo = reactive({
    modelLicens: []
})
const author = reactive({
    recommend: []
})
const recommendList = ref([])
const newsList = ref([])
const isLoading = ref(false)
watch(() => route.query.id, id => {
    currentTab.value = 0
    fetch()
}, { immediate: true })

function fetch() {
    isLoading.value = true
    http.get('/app-api/product/spu/get-product?id=' + route.query.id).then(res => {
        res.modelLicens.map(item => {
            item.scope = item.scope
                .replaceAll('√', '<img src="' + icon1 + '"  />')
                .replaceAll('×', '<img src="' + icon2 + '"  />')
        })
        Object.assign(modelInfo, res)
        isLoading.value = false
        http.get('/app-api/member/user/getByMall?userId=' + modelInfo.userId).then(res => {
            Object.assign(author, res)
        })
        http.get('/app-api/product/spu/page?pageNo=1&pageSize=3&sortField=updateTime&sortAsc=false&userId=' + modelInfo.userId).then(res => {
            author.assetCount = res.total
        })
        http.get('/app-api/product/spu/page?pageNo=1&pageSize=5&sortField=updateTime&sortAsc=false&userId=' + modelInfo.userId).then(res => {
            author.recommend = res.list
        })

        http.get('/app-api/product/spu/get-guess-like?cate=' + modelInfo.platformCate).then(res => {
            recommendList.value = res.slice(0, 2)
        })
    }).catch(err => {
        console.log(err);
    })

    // getModelRelatedArticle(route.query.id).then(res => {
    //     newsList.value = res.data.rows
    // })
}

const licenseType = ref(1)
function jumpToDetail(item) {
    router.replace({ path: '/assets-detail', query: { id: item.id } })
    window.scrollTo(0, 0)
}

const shareDialog = ref(null)

const toShare = () => {
    shareDialog.value.show(location.href, modelInfo.modelName, 2)
}

const likeModel = () => {
    modelInfo.isLike = !modelInfo.isLike
    http.post('/app-api/product/likes/dealLikes', {
        isLike: 0,
        spuId: modelInfo.id
    })
}

const favoriteModel = () => {
    modelInfo.isFavorite = !modelInfo.isFavorite
    if (modelInfo.isFavorite) {
        http.post('/app-api/product/favorite/create', {
            spuId: modelInfo.id
        })
    } else {
        http.delete('/app-api/product/favorite/delete?', {
            data: {
                spuId: modelInfo.id
            }
        })
    }

}
const goBack = () => {
    if (window.history.length > 1) {
        router.back()
    } else {
        router.replace('/')
    }
}

const toFollow = () => {
    http.get('/app-api/member/follow/follow?userId=' + author.id).then(res => {
        if (res) {
            author.follow = !author.follow
            author.followCount += author.follow ? 1 : -1
        }
    })
}

function getPrice(target) {
    if(!target){
        return '-'
    }
    if(target.downPerm == 2){
        return '禁止下载'
    }else if(target.downPerm == 3){
        return 'RMB: ' + target.licensPrice.toFixed(2) || '-'
    }else if(target.downPerm == 1){
        return '免费下载'
    }else{
        return '-'
    }
}

</script>

<style scoped lang="scss">
.assets_detail {
    background-color: #F6F6F6;
}

.model_wrapper {
    width: 100%;
    height: 300rem;
}

.model_info {
    padding: 30rem 15rem;

    ul {
        li {
            height: 30rem;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #E5E5E5;
            color: #808080;

            span {
                display: inline-block;
                width: 50%;
                color: #808080;
                padding-left: 50rem;
            }
        }
    }
}

header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: center;
    padding: 0 20rem;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 999;
    position: relative;

    .btn {
        position: absolute;
        left: 20rem;
    }

    .item {
        display: inline-block;
        height: 60rem;
        line-height: 60rem;
        padding: 0 20rem;
        color: #838385;
    }

    .active {
        color: #000;
        font-weight: bolder;
    }
}

.info {
    padding: 15rem;
    background-color: #fff;

    h5 {
        display: flex;
        justify-content: space-between;
        font-size: 18rem;

        >div {
            ::v-deep(.van-icon__image) {
                margin-left: 15rem;
            }
        }
    }

    p {
        display: flex;
        align-items: center;
        color: #797979;
        margin: 5rem 0;

        span {
            max-width: 80%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin: 0 5rem;
        }

    }
}

.licens {
    padding: 15rem;
    background-color: #fff;

    ::v-deep(.van-radio) {
        height: 32rem;
        border: 1px solid #F0F0F0;
        margin: 10rem 0;
        padding: 0 10rem;

        .van-radio__label {
            display: block;
            width: 100%;
        }

        .licens_item {
            width: 100%;
            font-size: 14rem;
            display: flex;
            justify-content: space-between;
        }
    }

    h5 {
        margin: 10rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
            font-weight: normal; margin-left: 5rem;
        }
        button {
            height: 30rem;
            background-color: #F1F1F1;
            border-radius: 16rem;
            padding: 0 15rem;
            border: none;
            font-size: 12rem;
            font-weight: normal;

            a {
                color: #2B2B2B;
            }
        }
    }

    .desc {
        padding: 10rem;

        ::v-deep(div) {
            display: flex;
            align-items: center;
            height: 26rem;

            img {
                width: 12rem;
                height: 12rem;
                margin-right: 5rem;
            }
        }
    }

}

.intro {
    margin-top: 10rem;
    background-color: #fff;
    padding: 15rem;

    .intro_content {
        min-height: 200rem;
    }
}

.author {
    padding: 15rem;
    background-color: #fff;
    margin-top: 10rem;

    img {
        width: 50rem;
        height: 50rem;
        border-radius: 50%;
    }

    .line {
        width: 100%;
        height: 2px;
        background-color: #F0F0F0;
        margin: 15rem 0;
    }

    .author_info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >img {
            width: 50rem;
            height: 50rem;
            border-radius: 50%;
        }

        >div {
            flex: 1;
            margin: 0 15rem;
        }

        p {
            color: #999;
            margin-top: 10rem;
        }

        >button {
            background-color: #000000;
            color: #FFF;
            border: none;
            width: 65rem;
            height: 26rem;
            line-height: 26rem;
        }
    }

    .list {
        width: 100%;
        overflow-x: scroll;
        margin: 10rem 0;

        ul {
            display: flex;
            flex-wrap: nowrap;
            width: 135rem;
            height: 107rem;

            li {
                background-size: cover;
                margin-right: 20rem;

                img {
                    width: 135rem;
                    height: 107rem;
                    object-fit: cover;
                }
            }
        }
    }

    .list::webkit-scrollbar {
        display: none;
    }
}

.articles {
    background-color: #fff;
    padding: 15rem;
}

.guess_like {
    padding: 15rem;

    h5 {
        margin: 10rem 0;
    }

    .list {
        display: flex;
        justify-content: space-between;

        li {
            width: 190rem;
        }
    }
}

footer {
    display: flex;
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 10;

    button {
        height: 48rem;
        width: 100%;
        border: none;
    }

    button:first-child {
        background-color: #FD0831;
        color: #FFF;
    }

    // button:last-child{
    //     background-color: #000000;
    //     color: #FFF;
    // }
}
</style>
